<template>
	<dp-modal :active="importActive" :title="$t('title.buildImport')" @close="showImport(false)">
		<label v-t="'action.buildImportExplanation'" label-for="build-import-url" />
		<textarea
			id="build-import-url"
			v-model="url"
			:class="{ 'is-danger': url && !seemsValid }"
			class="textarea has-text-tiny"
			type="url"
			@focus="$event.target.select()" />
		<label v-if="url && !seemsValid" v-t="'error.invalidBuildUrl'" class="has-text-danger" />
		<button
			slot="footer"
			v-t="'action.buildImport'"
			:disabled="!seemsValid"
			class="button is-primary"
			@click="importBuild" />
	</dp-modal>
</template>

<script>
import { tryCatch } from 'ramda';
import Url from 'url-parse';
import { mapState, mapActions } from 'vuex';

export default {
	data: () => ({ url: '' }),
	computed: {
		...mapState(['importActive']),
		parsedUrl() {
			const parseUrl = url => new Url(url);
			return tryCatch(parseUrl, logAndReturn({}))(this.url);
		},
		seemsValid() {
			return /[?&]data=/.test(this.parsedUrl.query);
		},
	},
	methods: {
		...mapActions(['showImport']),
		importBuild() {
			this.showImport(false);
			const { pathname, query } = this.parsedUrl;
			this.$router.push(pathname.concat(query));
			this.url = '';
		},
	},
};

function logAndReturn(value) {
	return err => {
		console.error(err);
		return value;
	};
}
</script>

<style scoped>
.textarea.has-text-tiny {
	font-size: 0.75rem;
}
</style>
